import React, {useState} from 'react';
import {Box} from '@mui/material';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';

const ImageWithFallback: React.FC<{
    src: string;
    sx?: Record<string, any>;
    fallbackSx?: Record<string, any>;
}> = ({src, sx, fallbackSx}) => {
    const [failed, setFailed] = useState(false);

    if (failed) {
        return (
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'grey.100',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.300',
                ...sx,
                ...fallbackSx,
            }}
            >
                <BrokenImageIcon sx={{fontSize: 40, color: 'grey.400'}} />
            </Box>
        );
    }

    return (
        <Box
            component={'img'}
            src={src}
            onError={() => setFailed(true)}
            sx={sx}
        />
    );
};

export default ImageWithFallback;
